import { RedirectFunction } from '@angular/router';
import { inject } from '@angular/core';
import { TokenStorageService } from "@app/core/services/token-storage.service";
import {UserRoles} from "@app/core/enums/userRoles.enum";

// Redirect function for home page, to automatically redirect a user
// to their proper dashboard if a token exists and is valid.
export const userTypeRedirect: RedirectFunction = () => {
  const tokenStorageService = inject(TokenStorageService);
  const user = tokenStorageService.getEffectiveUser();
  if(user == null) return '/portal-login';
  switch(user.role){
    case UserRoles.referralUser:
      return '/ref-dashboard';
    case UserRoles.adminUser:
      return '/admin-dashboard';
    case UserRoles.workCompUser:
      return '/wc-dashboard';
    default:
      return '/portal-login';
  }
}
